var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnvelope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_378_718)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 13.0063L16 4.11875L28 13.0063V15.9688L18.0938 23.3125C17.4875 23.7625 16.7563 24 16 24C15.2437 24 14.5125 23.7563 13.9062 23.3125L4 15.9688V13.0063ZM16 0C15.2437 0 14.5125 0.24375 13.9062 0.6875L1.61875 9.79375C0.6 10.55 0 11.7375 0 13.0063V28C0 30.2062 1.79375 32 4 32H28C30.2062 32 32 30.2062 32 28V13.0063C32 11.7375 31.4 10.5437 30.3813 9.79375L18.0938 0.6875C17.4875 0.24375 16.7563 0 16 0Z",
    fill: "#233C7E",
    fillOpacity: 0.25
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_378_718"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.34f0da4653a2df6a2556c9133fcd32cb.svg";
export { ForwardRef as ReactComponent };